module.exports = __webpack_public_path__ + "static/img/default-running-avatar.36051511.png";